export function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object;
}

export function snakeToCamel(str) {
  if (!str) return str;

  return str
    .toLowerCase()
    .replace(/^(_)+|(_)+$/g, '')
    .replace(/([_]+[a-z])/g, char => char.toUpperCase().replace('_', ''));
}

export function camelToSnake(str) {
  if (!str) return str;
  return str.replace(/([A-Z])/g, char => `_${char.toLowerCase()}`).replace(/^(_)+/g, '');
}

export function makePretty(str) {
  if (!str) return str;
  return camelToSnake(str)
    .replace(/(_)+/g, ' ')
    .trim()
    .replace(/^\w/, char => char.toUpperCase());
}

export function keysToCase(item, fn = () => {}) {
  if (Array.isArray(item)) return item.map(el => keysToCase(el, fn));

  if (isObject(item))
    return Object.entries(item).reduce(
      (acc, [key, value]) =>
        ['entities', 'check', 'labeling'].includes(key)
          ? { ...acc, [fn(key)]: value }
          : { ...acc, [fn(key)]: keysToCase(value, fn) },
      {},
    );

  return item;
}
